import axios from 'axios';
import { clearStorageKeepingThemes } from '@/helpers/theme';

/**
 * System Configuration on the client: any API answer that says the system is under
 * maintenance (503) or that this session was replaced by a sign-in elsewhere (401
 * session_replaced) signs the user out to the sign-in page, which shows why.
 * signOut() is also how the idle timer signs a user out.
 */

export const SIGNOUT_REASON_KEY = 'signoutReason';

export function signOut(reason = null) {
  try {
    if (reason) sessionStorage.setItem(SIGNOUT_REASON_KEY, JSON.stringify(reason));
  } catch (e) { /* the sign-in page shows no reason */ }
  // As the Logout page does: everything the session stored.
  try { clearStorageKeepingThemes(); } catch (e) { /* nothing stored */ }
  delete axios.defaults.headers.common.Authorization;
  const base = (process.env.BASE_URL || '/').replace(/\/?$/, '/');
  window.location.assign(`${base}login`);
}

/** The reason the user was last signed out ({ type, message }), read once. */
export function takeSignoutReason() {
  try {
    const raw = sessionStorage.getItem(SIGNOUT_REASON_KEY);
    sessionStorage.removeItem(SIGNOUT_REASON_KEY);
    return raw ? JSON.parse(raw) : null;
  } catch (e) {
    return null;
  }
}

let installed = false;

export function installSystemGuard() {
  if (installed) return;
  installed = true;

  axios.interceptors.response.use(
    response => response,
    error => {
      const status = error?.response?.status;
      const data = error?.response?.data || {};
      const signedIn = !!localStorage.getItem('jwt');

      if (signedIn && status === 503 && data.maintenance) {
        signOut({ type: 'maintenance', message: data.message });
      } else if (signedIn && status === 401 && data.code === 'session_replaced') {
        signOut({ type: 'session_replaced', message: data.message });
      }
      return Promise.reject(error);
    },
  );
}
